import { DARK_SDF_THEME, LIGHT_SDF_THEME, type SdfTheme } from '../rendering/sdfTheme.js';
import { resolveViewportRenderTheme } from './viewportRenderTheme.js';

export function getActiveSdfTheme(): SdfTheme {
  return resolveViewportRenderTheme() === 'light' ? LIGHT_SDF_THEME : DARK_SDF_THEME;
}
